import * as React from "react";
import { createRoot } from 'react-dom/client';
import { Provider } from "react-redux";
import { HelmetProvider } from 'react-helmet-async';
import {
    createBrowserRouter,
    RouterProvider,
} from "react-router-dom";
import { store } from "../store/index";
import { IMapOptions } from "../interfaces/mapoptions";
import { getMapOptions } from "../api/setup";
import { setLoaded, setInitialized } from "../reducers/mapkit";
import { setLoaded as setGoogleLoaded } from "../reducers/googlemaps";
import { setMapKit } from "../api/mapkit";
import MapContainerResults from "./mapcontainerresults";
import RightResults from "./rightresults";
import RightPoi from "./rightpoi";

const mapoptions = getMapOptions();

const router = createBrowserRouter([
    {
        path: "/:adr1/:adr2/:poiname/:travel",
        element: <MapContainerResults />,
        children: [
            {
                path: "",
                element: <React.Fragment />
            },
            {
                path: ":poiId",
                element: <RightPoi />
            },
        ]
    }
], {
    basename:
        mapoptions.basename
});

//console.log(mapoptions.basename);
//console.log(window.location.href);

// used when we are using apple mapkit. 
export function createMapKit(mapkit) {
    //console.log("mapkit loaded");
    // set the mapkit in the store
    store.dispatch(setLoaded(true));
    setMapKit(mapkit);
}

// used when we are using apple mapkit. Updates if
// the map has been initialized and ready to draw
export function initMapKit() {
    //console.log("mapkit initialized");
    // set the mapkit in the store
    //store.dispatch(setMapKit(mapkit));
    store.dispatch(setInitialized(true));
}

// used when we are using google maps. It's called when
// we're ready to draw on google maps.
export function initGoogleMaps() {
    store.dispatch(setGoogleLoaded(true));
    //console.log("Google maps ready");
}

const container = document.getElementById('content');
const root = createRoot(container!);
root.render(<Provider store={store}>
    <HelmetProvider>
        <RouterProvider router={router} />
    </HelmetProvider>
</Provider>);
